import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerClose,
} from '@/components/ui/drawer';
import useMediaQuery from '@/hooks/useMediaQuery';
import { cn, truncateText } from '@/lib/utils';
import { XIcon } from 'lucide-react';

export interface ModalResponsiveProps extends React.HtmlHTMLAttributes<HTMLElement> {
  openModal?: boolean;
  setOpenModal?: (open: boolean) => void;
  title?: string;
  classNameMobile?: string;
}

export default function ModalResponsive({
  openModal,
  setOpenModal,
  title,
  children,
  className,
  classNameMobile,
}: ModalResponsiveProps) {
  const isMobile = useMediaQuery(768);

  if (isMobile) {
    return (
      <Drawer open={openModal} onOpenChange={setOpenModal}>
        <DrawerContent className={cn(classNameMobile)}>
          <DrawerHeader className='flex items-center justify-between px-6 py-6 text-left'>
            <DrawerTitle className='text-wrap break-words'>{title}</DrawerTitle>
            <DrawerClose>
              <XIcon className='h-4 w-4' />
            </DrawerClose>
          </DrawerHeader>
          {children}
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={openModal} onOpenChange={setOpenModal}>
      <DialogContent className={className || 'max-w-4xl'}>
        {!!title && (
          <DialogHeader>
            <DialogTitle className='max-w-full whitespace-normal break-words text-lg'>
              {truncateText(title, 70) || 'Untitled'}
            </DialogTitle>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
}

export function ModalResponsiveFooter({
  children,
  ...props
}: React.HtmlHTMLAttributes<HTMLElement>) {
  const isMobile = useMediaQuery(768);
  if (isMobile) {
    return <DrawerFooter {...props}>{children}</DrawerFooter>;
  }

  return <DialogFooter {...props}>{children}</DialogFooter>;
}
